<template>
    <form 
        role="form" 
        class="row" 
        @submit.prevent="submit">
        <div class="col-sm-6">
            <div class="form-group">
                <label for="name">Ime</label>
                <input 
                    id="name"
                    v-model="rowData.name"
                    type="text"
                    class="form-control"
                    name="name"
                    placeholder="ime">
            </div>
            <div class="form-group">
                <label for="sex">Spol</label>
                <select 
                    id="sex" 
                    v-model="rowData.sex" 
                    class="form-control">
                    <option value="neutral">nedoločen</option>
                    <option value="male">moški</option>
                    <option value="female">ženski</option>
                </select>
            </div>
            <div class="form-group">
                <label for="email">E-pošta</label>
                <input 
                    id="email"
                    v-model="rowData.email"
                    type="email"
                    class="form-control"
                    name="email"
                    placeholder="e-pošta">
            </div>
            <div class="form-group">
                <label for="phone">Telefon</label>
                <input 
                    id="phone"
                    v-model="rowData.phone"
                    type="tel"
                    class="form-control"
                    name="phone"
                    placeholder="telefon">
            </div>
            <div class="form-group">
                <label for="birthday">Datum rojstva</label>
                <input 
                    id="birthday"
                    v-model="rowData.birthday"
                    type="date"
                    class="form-control"
                    name="birthday"
                    placeholder="datum rojstva">
            </div>
            <div class="form-group">
                <label for="phone">Davčna št.</label>
                <input 
                    id="tax_id"
                    v-model="rowData.tax_id"
                    type="text"
                    class="form-control"
                    name="tax_id"
                    placeholder="Davčna številka">
            </div>
        </div>
        <div class="col-sm-6">
            <div class="form-group">
                <label for="address">Naslov</label>
                <input 
                    id="address"
                    v-model="rowData.address"
                    type="text"
                    class="form-control"
                    name="address"
                    placeholder="naslov">
            </div>
            <div class="form-group">
                <label for="post">Pošta</label>
                <multiselect 
                    id="post"
                    v-model="rowData.post"
                    :options="posts"
                    :custom-label="multiselectPostLabel"
                    :close-on-select="true"
                    selected-label="Izbrano"
                    select-label="Pritisnite enter za izbor"
                    deselect-label="Pritisnite enter za ostranitev izbora"
                    placeholder="Izberi pošto"
                    track-by="id"
                    label="name"
                    @input="postChanged"/>
            </div>
            <div class="form-group">
                <label for="municipality">Občina</label>
                <multiselect 
                    id="municipality"
                    v-model="rowData.municipality"
                    :options="municipalities"
                    :custom-label="multiselectLabel"
                    :close-on-select="true"
                    :disabled="municipalityDisabled()"
                    selected-label="Izbrano"
                    select-label="Pritisnite enter za izbor"
                    deselect-label="Pritisnite enter za ostranitev izbora"
                    placeholder="Izberi občino"
                    track-by="id"
                    label="name"
                    @input="municipalityChanged"/>
            </div>
            <div class="form-group">
                <label for="country">Regija</label>
                <multiselect 
                    id="region"
                    v-model="rowData.region"
                    :options="regions"
                    :custom-label="multiselectLabel"
                    :close-on-select="true"
                    :disabled="regionDisabled()"
                    selected-label="Izbrano"
                    select-label="Pritisnite enter za izbor"
                    deselect-label="Pritisnite enter za ostranitev izbora"
                    placeholder="Izberi regijo"
                    track-by="id"
                    label="name"
                    @input="regionChanged"/>
            </div>
            <div class="form-group">
                <label for="country">Država</label>
                <multiselect 
                    id="country"
                    v-model="rowData.country"
                    :options="countries"
                    :custom-label="multiselectLabel"
                    :close-on-select="true"
                    :disabled="countryDisabled()"
                    selected-label="Izbrano"
                    select-label="Pritisnite enter za izbor"
                    deselect-label="Pritisnite enter za ostranitev izbora"
                    placeholder="Izberi državo"
                    track-by="id"
                    label="name"/>
            </div>
        </div>
        <div class="col-sm-12">
            <button 
                type="submit"
                class="btn btn-success">
                Posodobi
            </button>
        </div>
    </form>
</template>

<script>
import TableDetails   from '../../../mixins/TableDetails';
import ContactsCommon from '../../../mixins/Contacts';
import Multiselect    from 'vue-multiselect';

export default {
    name: 'ContactDetails',

    components: {
        Multiselect
    },

    mixins: [
        TableDetails,
        ContactsCommon
    ],

    data() {
        return {
            apiUrl:                 '/ajax/contact_versions',
            forceReloadAfterSubmit: true
        };
    },

    methods: {
        prepareUpdateData() {
            let data = (
                ({email, phone, tax_id, name, sex, birthday, address}) =>
                    ({email, phone, tax_id, name, sex, birthday, address})
            )(this.rowData);

            data['post_id'] = this.rowData.post != null ? this.rowData.post.id : '';
            data['municipality_id'] = this.rowData.municipality != null ? this.rowData.municipality.id : '';
            data['region_id'] = this.rowData.region != null ? this.rowData.region.id : '';
            data['country_id'] = this.rowData.country.id;

            return data;
        },

        postChanged(item) {
            axios.get(`/ajax/posts/${item.id}/relations`)
                .then(response => {
                    let post = response.data.data;

                    if (post != null) {
                        if ('municipality' in post) {
                            this.$set(this.rowData, 'municipality', post.municipality);

                            if ('region' in post.municipality) {
                                this.$set(this.rowData, 'region', post.municipality.region);

                                if ('country' in post.municipality.region) {
                                    this.$set(this.rowData, 'country', post.municipality.region.country);
                                }
                            }
                        }
                    }
                })
                .catch(error => {
                    if ('errors' in error.response.data && error.response.data.errors) {
                        for (let field in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(field)) {
                                this.$toast.error({
                                    title:   'NAPAKA!',
                                    message: error.response.data.errors[field][0],
                                    timeOut: 10000
                                });
                            }
                        }
                    }
                });
        },

        municipalityChanged(item) {
            axios.get(`/ajax/municipalities/${item.id}/relations`)
                .then(response => {
                    let municipality = response.data.data;

                    if ('region' in municipality) {
                        this.$set(this.rowData, 'region', municipality.region);

                        if ('country' in municipality.region) {
                            this.$set(this.rowData, 'country', municipality.region.country);
                        }
                    }
                })
                .catch(error => {
                    if ('errors' in error.response.data && error.response.data.errors) {
                        for (let field in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(field)) {
                                this.$toast.error({
                                    title:   'NAPAKA!',
                                    message: error.response.data.errors[field][0],
                                    timeOut: 10000
                                });
                            }
                        }
                    }
                });
        },

        regionChanged(item) {
            axios.get(`/ajax/regions/${item.id}/relations`)
                .then(response => {
                    let region = response.data.data;

                    if (region != null) {
                        this.$set(this.rowData, 'region', region);

                        if ('country' in region) {
                            this.$set(this.rowData, 'country', region.country);
                        }
                    }
                })
                .catch(error => {
                    if ('errors' in error.response.data && error.response.data.errors) {
                        for (let field in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(field)) {
                                this.$toast.error({
                                    title:   'NAPAKA!',
                                    message: error.response.data.errors[field][0],
                                    timeOut: 10000
                                });
                            }
                        }
                    }
                });
        },

        municipalityDisabled() {
            return (this.rowData.post != null && this.rowData.post.id !== '');
        },

        regionDisabled() {
            return (this.municipalityDisabled() || this.rowData.municipality != null);
        },

        countryDisabled() {
            return (this.regionDisabled() || this.rowData.region != null);
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Contacts/Components/ContactVersionDetails.vue